import { useContext, useState } from 'react'

import { Modal, Input, DateInput, Textarea } from '../ui_new'
import { dateValueFormat } from '../../utils'
import { Send } from '@material-ui/icons'
import { Close } from '../../assets/icons'
import { NotificationContext } from '../../context'

const ContactInputModal = ({ onClose, onSubmit, title }) => {

  const { setNotification } = useContext(NotificationContext)
  const [firstname, setFirstname] = useState('')
  const [lastname, setLastname] = useState('')
  const [email, setEmail] = useState('')

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault()
    if(!firstname || !lastname || !email) {
      setNotification({
        type: 'danger',
        msg: 'Veuillez remplir tous les champs.'
      })
      return
    }
    onSubmit({
      firstname,
      lastname,
      email
    })
    onClose()
  }

  return (
    <Modal onClose={onClose} className="modal-v2--no-padding modal-v2--medium-3">
      <div className="synthesis-modal-v2 validation-modal">
        <div className='folder-modal-v2__heading'>
          <div className='signature-heading'>
            <div>
              <h1>{title || 'Contact'}</h1>
            </div>
          </div>
          <div className="synthesis-form__actions buttons-row">
            <button className="btn btn--transparent" onClick={onClose}>Annuler</button>
            <button className="btn btn--with-icon btn--large" onClick={handleSubmit}> Soumettre</button>
          </div>
        </div>
        <div className='folder-modal-v2__content'>
          <div className="synthesis-modal-v2__body">
            <div className="synthesis-v2">
              <div className="synthesis-form">
                <div className="input-wrapper">
                  <Input
                    value={firstname}
                    type="string"
                    onChange={(e) => setFirstname(e.target.value)}
                    className={firstname ? 'not-empty' : ''}
                    label={'Prénom'}
                    placeholder={'Prénom'}
                    required />
                </div>
                <div className="input-wrapper mt-2">
                  <Input
                    value={lastname}
                    type="string"
                    onChange={(e) => setLastname(e.target.value)}
                    className={lastname ? 'not-empty' : ''}
                    label={'Nom'}
                    placeholder={'Nom'}
                    required />
                </div>
                <div className="input-wrapper mt-2">
                  <Input
                    value={email}
                    type="string"
                    onChange={(e) => setEmail(e.target.value)}
                    className={email ? 'not-empty' : ''}
                    label={'Email'}
                    placeholder={'Email'}
                    required />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ContactInputModal
